import { render, staticRenderFns } from "./accessoriyDetail.vue?vue&type=template&id=e656e3c0&scoped=true"
import script from "./accessoriyDetail.vue?vue&type=script&lang=js"
export * from "./accessoriyDetail.vue?vue&type=script&lang=js"
import style0 from "./accessoriyDetail.vue?vue&type=style&index=0&id=e656e3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e656e3c0",
  null
  
)

export default component.exports